import api from './api';

const getDashboardData = (clientId) => {
  return api.get(`/dashboard/${clientId}`);
};

const getAvailableModules = (clientId) => {
  return api.get(`/dashboard/available-modules/${clientId}`);
};

const dashboardService = {
  getDashboardData,
  getAvailableModules,
};

export default dashboardService;